var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('validation-provider',{attrs:{"name":_vm.name},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('v-checkbox',{attrs:{"value":_vm.inputValue,"label":_vm.label,"prepend-icon":_vm.icon,"error-messages":errors},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }